var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15632 16.8276L3.58936 21.6244H22.4106L21.635 19.25H7.578V18.75H21.4717L20.8432 16.8263V9.34346C20.8432 5.01164 17.3316 1.5 12.9998 1.5C8.66796 1.5 5.15632 5.01163 5.15632 9.34345V16.8276ZM21.9977 18.75L21.3432 16.7467V9.34346C21.3432 4.73549 17.6077 1 12.9998 1C8.39181 1 4.65632 4.73549 4.65632 9.34345V16.748L2.90002 22.1244H10.0922V22.5C10.0922 23.8772 11.445 24.9104 13.0001 24.9104C14.5551 24.9104 15.9079 23.8772 15.9079 22.5V22.1244H23.1L22.0091 18.785V18.75H21.9977ZM10.5922 22.1244H15.4079V22.5C15.4079 23.5092 14.3808 24.4104 13.0001 24.4104C11.6193 24.4104 10.5922 23.5092 10.5922 22.5V22.1244Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9f276e64.svg";
export { ForwardRef as ReactComponent };